import { useMemo } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import { includes } from 'lodash-es'

import { selectWebview } from 'store/webview/webviewSlice'

const routesPreventInitial = [
  '/login/vender-staff/line-bot',
  '/vender-staff/reservation/[reservationId]/upload-processing-images',
  '/album/[albumUrlId]',
  '/reservation/[reservationId]/[orderStatus]',
  '/self-construct-singlereservation',
  '/service/[identityCode]',
  '/service/[identityCode]/booking',
  '/service/[identityCode]/checkout',
  '/error',
  '/404',
  '/500',
]

export const useOmnichatEnableListener = () => {
  const webview = useSelector(selectWebview)
  const router = useRouter()

  const enabled = useMemo(() => {
    if (router.isReady && webview.initialized && webview?.name !== 'lsApp') {
      // 如果是中華電信行銷頁則不初始化 Omnichat
      // TODO: 未來若類似需求越來越多則可改用陣列或其他方式管理
      const actualPath = router.asPath.split('?')[0]
      if (actualPath === '/olmkt/cht') return false

      return !includes(routesPreventInitial, router.pathname)
    } else {
      return false
    }
  }, [router.isReady, webview?.initialized])

  return { enabled }
}
